import { useBrowserLayoutEffect } from "@biom3/react";
import { animate } from "motion/react";
import { type RefObject, useCallback } from "react";

export function useTopHeroScrollMotion({
  heroImageRef,
  isIntersecting,
  useVariantBExperiment = false,
}: {
  heroImageRef: RefObject<HTMLImageElement>;
  isIntersecting: boolean;
  useVariantBExperiment?: boolean;
}) {
  const handleScroll = useCallback(
    (event: Event) => {
      // @NOTE: if we're not yet properly setup, early exit,
      // and dont do any calcs etc.
      if (event.target === null || !isIntersecting || !heroImageRef.current) {
        return;
      }

      const currentScrollY = (event.target as HTMLDivElement).scrollTop;
      const translateY = currentScrollY * (useVariantBExperiment ? 0.06 : 0.18);
      animate(heroImageRef.current, { y: translateY }, { duration: 0 });
    },
    [isIntersecting, heroImageRef, useVariantBExperiment],
  );

  useBrowserLayoutEffect(() => {
    // @NOTE: bind the scroll event to the scrollable container
    const scrollableContainer = document.querySelector(
      "#rootScrollableContainer",
    );
    if (scrollableContainer) {
      scrollableContainer.addEventListener("scroll", handleScroll);
    }

    // @NOTE: cleanup the event listener
    return () => {
      if (scrollableContainer) {
        scrollableContainer.removeEventListener("scroll", handleScroll);
      }
    };
  }, [handleScroll]);
}
